export default __webpack_public_path__ + "assets/enterprise-one-five.0b18bd00c1ea9c54e452262ecdf805b8.png";